import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import Stripe from 'stripe';
import { StripeService } from '../../core/services/stripe.service';
import { ModalService } from '../../core/services/modal.service';
import { SavedPaymentsMethodsService } from '../../core/services/data/saved-payment-methods.service';

@Component({
	selector: 'app-list-stripe-cards-modal',
	templateUrl: './list-stripe-cards-modal.component.html',
	styleUrls: ['./list-stripe-cards-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class ListStripeCardsModalComponent implements OnInit {
	@Input() customer: Stripe.Customer;

	@Input() currentSubscription;

	@Input() user;

	@Output() selectedCard = new EventEmitter();

	public cards;

	public cardRemove;

	public buttonText = { confirm: 'Confirm', cancel: 'Cancel' };

	public confirmText;

	public successText;

	public success;

	public loading = false;

	get primaryPaymentMethod() {
		return this.customer?.invoice_settings?.default_payment_method;
	}

	constructor(
		private ms: ModalService,
		private ss: StripeService,
		private savedPaymentMethodsService: SavedPaymentsMethodsService,
	) {
	}

	ngOnInit() {
		this.getCards(false);
	}

	getCards(event) {
		this.loading = true;
		const arrayCards = this.ss.cards;
		this.savedPaymentMethodsService.getSavedCards().subscribe((cards: any) => {
			this.cards = cards;
			this.cards.forEach((card, index) => {
				const cardBrand = card.card.brand;
				for (const [key, value] of Object.entries(arrayCards[0])) {
					if (`${key}` === cardBrand) {
						card.card.brand = `${value}`;
					}
				}
			});
			this.loading = false;
		});

		// this.ss.getCards(this.user.stripeCustomerId).subscribe((data: any) => {
		// 	if (data.success) {
		// 		this.cards = data.card.cards.data;
		// 		this.cards.forEach((card, index) => {
		// 			const cardBrand = card.card.brand;
		// 			for (const [key, value] of Object.entries(arrayCards[0])) {
		// 				if (`${key}` === cardBrand) {
		// 					card.card.brand = `${value}`;
		// 				}
		// 			}
		// 		});
		// 		this.loading = false;
		// 	} else {
		// 		this.loading = false;
		// 	}
		// });
	}

	ok() {
		this.ms.close('list-cards');
	}

	cancel() {
		this.ms.close('list-cards');
	}

	removeCard(card) {
		this.confirmText = 'Are you sure you want to delete the card?';
		this.ms.open('remove-Card');
		this.cardRemove = card;
	}

	comfirmRemoveCard(event) {
		if (event) {
			// this.ss.removeCard(this.cardRemove.id).subscribe((data: any) => {
			// 	if (data.success) {
			// 		this.successText = 'Card removed successfully';
			// 		this.ms.open('success-removeCard');
			// 	}
			// });
			// Request above removes the payment method from stripe. This one removes it JUST from our DB. We might want both. - Jordan 6/20/2024
			this.savedPaymentMethodsService.remove(this.cardRemove.id).subscribe((data: any) => {
				if (data.success) {
					this.successText = 'Card removed successfully';
					this.ms.open('success-removeCard');
				}
			});
		}
	}

	setSelectedCard(card) {
		this.selectedCard.emit(card);
		this.ok();
	}

	addNewCard() {
		this.ms.close('list-cards');
		this.ms.open('add-card-form');
	}
}
